<template>
    <Head title="Google Sheets Sync" />

    <MainLayout>
        <PageHeader title="Синхронизация Google Sheets">
            <p class="page-subtitle">Игроки (`users`), команды (`teams`), команды по сезонам (`team_seasons`), составы (`team_season_user`), матчи (`games`)</p>
        </PageHeader>

        <div class="sheets-sync-page">
            <div class="sheets-sync-report" style="margin-bottom: 1.5rem;">
                <h3>Статус</h3>
                <ul>
                    <li>Включено: {{ status.enabled ? 'да' : 'нет' }}</li>
                    <li>Spreadsheet ID: {{ status.spreadsheet_id || '—' }}</li>
                    <li>Последний push в Sheets: {{ status.last_push_at || '—' }}</li>
                    <li v-if="status.last_error">
                        Последняя ошибка push: {{ status.last_error.at }} — {{ status.last_error.message }}
                    </li>
                </ul>
                <p style="margin-top: 0.75rem;">
                    БД → Sheets обновляется автоматически при сохранении записей.
                    Export / Import ниже действуют на один выбранный лист.
                    Import — зеркало листа в БД (строки, которых нет в листе, удаляются).
                    Export — полная перезаливка листа из БД (recovery).
                </p>
            </div>

            <div class="sheets-sync-sections">
                <section
                    v-for="sheet in sheets"
                    :key="sheet.sheet"
                    class="sheets-sync-section"
                >
                    <h3 class="sheets-sync-section__title">
                        {{ sheet.label }}
                        <code class="sheets-sync-section__code">{{ sheet.sheet }}</code>
                    </h3>
                    <div class="sheets-sync-actions">
                        <Link
                            :href="route('admin.sheets-sync.export', sheet.sheet)"
                            method="post"
                            as="button"
                            class="btn btn-primary sheets-sync-btn"
                            :disabled="!status.enabled"
                            :aria-label="`Экспорт ${sheet.label} в Google Sheets`"
                            :title="`Экспорт «${sheet.sheet}» в Google Sheets`"
                        >
                            <span class="sheets-sync-btn__icons" aria-hidden="true">
                                <img src="/images/icons/database.png" alt="" class="sheets-sync-btn__icon" />
                                <span class="sheets-sync-btn__arrow">→</span>
                                <img src="/images/icons/google-sheets.webp" alt="" class="sheets-sync-btn__icon" />
                            </span>
                        </Link>
                        <Link
                            :href="route('admin.sheets-sync.import', sheet.sheet)"
                            method="post"
                            as="button"
                            class="btn btn-secondary sheets-sync-btn"
                            :disabled="!status.enabled"
                            :aria-label="`Импорт ${sheet.label} из Google Sheets`"
                            :title="`Импорт «${sheet.sheet}» из Google Sheets`"
                        >
                            <span class="sheets-sync-btn__icons" aria-hidden="true">
                                <img src="/images/icons/google-sheets.webp" alt="" class="sheets-sync-btn__icon" />
                                <span class="sheets-sync-btn__arrow">→</span>
                                <img src="/images/icons/database.png" alt="" class="sheets-sync-btn__icon" />
                            </span>
                        </Link>
                    </div>
                </section>
            </div>

            <div v-if="flashSuccess" class="sheets-sync-report" style="margin-top: 1rem;">
                <p>{{ flashSuccess }}</p>
            </div>
            <p v-if="flashError" class="sheets-sync-error" style="margin-top: 1rem;">{{ flashError }}</p>
        </div>
    </MainLayout>
</template>

<script setup>
import { computed } from 'vue';
import { Head, Link, usePage } from '@inertiajs/vue3';
import MainLayout from '@/components/layout/MainLayout.vue';
import PageHeader from '@/components/layout/PageHeader.vue';

defineProps({
    status: {
        type: Object,
        required: true,
    },
    sheets: {
        type: Array,
        required: true,
    },
});

const page = usePage();
const flashSuccess = computed(() => page.props.flash?.success || null);
const flashError = computed(() => {
    const errors = page.props.errors || {};
    return errors.message || null;
});
</script>
